import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { PARAM_REQUESTS_PATH } from "src/app/admin/constants/constants";
import { Clients } from "src/app/models/clients";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { environment } from "src/environments/environment";
import { Requests } from "src/app/models/requests";
import { RequestsService } from "src/app/services/requests.service";

import { DynamicFiltersComponent } from "src/app/components/dynamic-filters/dynamic-filters.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DrawerModule } from "primeng/drawer";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { NgxPaginationModule } from "ngx-pagination";
import { Ripple } from "primeng/ripple";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { TopNavComponent } from "../../../top-nav/top-nav.component";

@Component({
    selector: "app-manage-requests",
    templateUrl: "./manage-requests.component.html",
    imports: [DynamicFiltersComponent, ButtonModule, CardModule, ConfirmDialogModule, DrawerModule, SharedModule, FormsModule, InputTextModule, NgxPaginationModule, Ripple, SelectModule, TableModule, TagModule, ToastModule, TopNavComponent]
})
export class ManageRequestsComponent extends AbstractListController<
  Requests,
  any
> {
  title = "Corsi";
  imageUrl: string;
  pages: Requests[];
  pageUrl = PARAM_REQUESTS_PATH;

  constructor(
    protected requestsService: RequestsService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(
      requestsService,
      confirmationService,
      router,
      route,
      PARAM_REQUESTS_PATH
    );
    this.imageUrl = environment.news_image_url;

    this.cols.set([
      { field: "name", header: "Nome & Cognome" },
      { field: "email", header: "Email" },
      { field: "phone", header: "Cellulare" },
      { field: "created_date", header: "Data" },
    ])

    this.colsFilter.set([
      { field: "name", header: "Nome & Cognome", type: "string" },
    ])


    this.setupDynamicFilters();
  }



}
